/*
 *
 * Transactions Actions
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 12-Jan-2023
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_RESET_ERROR: '@@Transactions/reset_error',
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@Transactions/set_item_to_show_detail',
	DO_SET_REVERSE_AMOUNT: '@@Transactions/set_reverse_amount',
	// @generator action:route:type
	...createRequestTypes('@@Transactions', 'FETCH_TRANSACTION_DETAIL'),
	...createRequestTypes('@@Transactions', 'FETCH_TRANSACTION_REVERSE'),
	...createRequestTypes('@@Transactions', 'DOWNLOAD_TRANSACTIONS_REPORT'),
  ...createRequestTypes('@@Transactions', 'GENERATE_TRANSACTIONS_REPORT_STATUS'),
	...createRequestTypes('@@Transactions', 'DO_ACCOUNTING'),
	...createRequestTypes('@@Transactions', 'FETCH_REVERSING'),
  ...createRequestTypes('@@Transactions', 'REPORT_PROGRESS'),

	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------
/** @action request
 * * Insert a description
 * @name generateTransactionsReportStatus
 * @return {object} - The action object
 */
export const generateTransactionsReportStatus = new MakeRequest('Transactions', 'generate_transactions_report_status');
/** @action request
 *
 * * Insert a description
 * @name transactionDetail
 * @return {object} - The action object
 */
export const fetchTransactionDetail = new MakeRequest('Transactions', 'fetch_transaction_detail');

/** @action request
 * * Insert a description
 * @name doReversing
 * @return {object} - The action object
 */
export const fetchReversing = new MakeRequest('Transactions', 'fetch_reversing');
/** @action request
 * * Insert a description
 * @name doAccounting
 * @return {object} - The action object
 */
export const doAccounting = new MakeRequest('Transactions', 'do_accounting');
/** @action request
 * * Insert a description
 * @name downloadTransactionReport
 * @return {object} - The action object
 */
export const downloadTransactionReport = new MakeRequest('Transactions', 'download_transactions_report');

/** @action request
 * * Insert a description
 * @name reportProgress
 * @return {object} - The action object
 */
export const reportProgress = new MakeRequest('Transactions', 'report_progress');
// @generator action:route:request

/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });

/** @action
 * * Insert a description
 * @name SetReverseAmount
 * @return {object} - The payload object
 */
export const doSetReverseAmount = (payload) => createAction(actionTypes.DO_SET_REVERSE_AMOUNT, { payload });


// @generator action:route
